/**
 * useStudentTutoringState — les gestes de « Messages ».
 *
 * L'onglet garde les tuteurs et leurs conversations (Wajih, 18/10) : ses prochains lives et leurs
 * gestes sont partis sur l'accueil et dans « Tous mes lives » (`useStudentLiveSessionsListState`).
 *
 * Les routes poussées sont celles de l'écran legacy, avec ses paramètres : `messenger` (vide pour
 * le tuteur principal, `tutorId` pour un autre — `MyCoachTabScreen.js:465-479`), `start-trial` ; et
 * « Une question ? » écrit au support (`openSupportEmail`).
 */
import { useMemo } from "react"
import { useNavigation } from "@react-navigation/native"

import { conversationTutorId } from "../../../../adapters/student/Messaging/studentConversationAdapter"
import { openSupportEmail } from "../../../hooks/openSupportEmail"
import { type UITutor } from "../../../types"

export type UseStudentTutoringStateArgs = {
    mainTutorId: UITutor["id"] | null
}

export function useStudentTutoringState(args: UseStudentTutoringStateArgs) {
    const { mainTutorId } = args
    const navigation = useNavigation<{ push: (name: string, params?: Record<string, unknown>) => void }>()

    return useMemo(
        () => ({
            openMessages: (tutor: UITutor) => {
                const tutorId = conversationTutorId(tutor.id, mainTutorId)
                navigation.push("messenger", tutorId == null ? {} : { tutorId })
            },
            startTrial: () => navigation.push("start-trial"),
            askQuestion: openSupportEmail,
        }),
        [navigation, mainTutorId]
    )
}
